function Header() {
    return (
        <header className="header">

            <div className="logo">
                <a href="/">
                    <img
                        src="/Fotos/IMG_0645.png"
                        alt="IRJ Logo"
                    />
                </a>
            </div>

            <div className="werbung">
                <p>
                    <b>IRJ-Tantramassagen</b>
                    <br />
                    Intuitive – Relax – Joy
                    <br />
                    <i>Dein Tantramasseur im Sarganserland.</i>
                </p>
            </div>

        </header>
    );
}

export default Header;